export default __webpack_public_path__ + "static/media/mug.81d17b6f.png";